import React from 'react';

import { Spinner } from '@lightspeed/flame/Spinner';
import { Text } from '@lightspeed/flame/Text';

import { NOT_AVAILABLE } from 'root/apps/QuoteMachineIntegration/components/PaymentRequest/TotalsSection/messages';
import {
  TotalRowText,
  TotalsRow,
} from 'root/apps/QuoteMachineIntegration/components/PaymentRequest/TotalsSection/styles';
import WarningTooltip from 'root/apps/QuoteMachineIntegration/WarningTooltip';

type Props = {
  label: string;
  loading: boolean;
  value: string | number;
  notAvailable: boolean;
  showWarning: boolean;
  warningToolTipText: string;
};

export const PaymentRequestTotalsRow: React.FC<Props> = ({
  label,
  loading,
  value,
  notAvailable,
  showWarning,
  warningToolTipText,
}) => {
  // show warning badge conditionally if one or both the totals failed to fetch
  if (notAvailable) {
    return (
      <TotalsRow>
        <TotalRowText>
          {showWarning && <WarningTooltip content={warningToolTipText} />}
          {label}
        </TotalRowText>
        <Text>{NOT_AVAILABLE}</Text>
      </TotalsRow>
    );
  }

  // otherwise show the value or a spinner if loading
  return (
    <TotalsRow>
      <TotalRowText>{label}</TotalRowText>
      <Text>{loading ? <Spinner /> : value}</Text>
    </TotalsRow>
  );
};
